import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import courseImg from '../../template/images/course.png';
import showAlert from "../alert/Alert";
import { get, post } from '../../util/axiosConfig/AxiosConfig';
import moment from "moment";
import StarRatings from "react-star-ratings";


const CourseItem = (props) => {
    const { title, author, duration, price, courseId, courseImg, courseData, selectedCategory, courseTypeName, offerPrice, isActiveOffer, offerName, offerEndDate, launch, specialOfferName,rating, feedbackShowInWeb } = props;
    const navigate = useNavigate();
    const { courseIDFromUrl } = useParams();
    const[existingFlag, setExistingFlag] = useState('');
    const [loading, setLoading] = useState(false);


    useEffect(()=>{
        checkExisting();
       
    },[]);

    const checkExisting = () => {
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(userObj.existingFlag == true){
            setExistingFlag(true);
        }else{
            setExistingFlag(false);
        }
    }

    const handleSubscription = () => {
        navigate(`/subscription/${courseId}`)
        localStorage.setItem("unit",courseId)
        localStorage.setItem("type",courseTypeName)
        localStorage.setItem("launch",moment(launch).format('DD-MM-YYYY'))

    }

    const handleBuyNow = () => {
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        localStorage.setItem("unit",courseId)
        localStorage.setItem("type",courseTypeName) 
        localStorage.setItem("launch",moment(launch).format('DD-MM-YYYY'))
        localStorage.setItem("activeOffer",isActiveOffer) 
        if(isActiveOffer == null) {
            localStorage.setItem('amount', price )
            localStorage.removeItem('offerPrice', offerPrice)
            
        } else {
           
            localStorage.setItem('offerPrice', offerPrice)
            

        }
        if(existingFlag == true){
            // redirectToLoginPage();
            addtoCart(userObj.userId, localStorage.getItem('unit'));
            showAlert('', 'Item added to your cart successfully', 'success', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
        }else{
            navigate(`/CreateAccount`)
            localStorage.setItem("unit",courseId)
            localStorage.setItem("type",courseTypeName) 
            localStorage.setItem("activeOffer",isActiveOffer) 
            if(isActiveOffer) {
                localStorage.setItem('offerPrice', offerPrice)
            } else {
                localStorage.removeItem('offerPrice', offerPrice)
    
            }
        }
       
    }

    const addtoCart = async (userId,unitId ) => {
        try {
            setLoading(true);
            const response = await get(`web/api/v1/lms-web/register/cart?userId=${userId}&planId=0&unitId=${unitId}`);
        } catch (error) {
            setLoading(false);
            showAlert('', 'Selected plan already exists in your account.', 'error', 'Continue Shopping',false,false, continueShopping, true,'Proceed to checkout', proceedToCheckout);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const continueShopping = (value) => {
        const userObj = JSON.parse(localStorage.getItem('userObj'))
        if(value === true){
            navigate('/Home?id='+userObj.userId);
        }
    }

    const proceedToCheckout = (value) => {
        if(value === true){
            redirectToLoginPage();
        }
    }

    const redirectToLoginPage = () => {
        window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app/NewDashboard`, '_blank');
    }

    const handleKnowMore = (e) => {
        e.preventDefault()
        navigate(`/courseView/${courseId}`)
    }

    const handleTeamsRedirect = () => {
        navigate('/EnquiryForm?cataGory='+selectedCategory+'&courseId='+courseData.id);
    }

    const text = 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and';

    return (
        <React.Fragment>
            <div className="card course_card">
                <img src={courseImg} className="card-img-top course_image" alt="Course image" />
                <div className="card-body">
                    <h5 className="card-title course_title">{title}</h5>
                    <div className="authorsAndtime">
                       {author ? <p className="author_name">By - {author}</p> : null}
                        {/* <span className="auth_icon"><i className="fa-regular fa-circle-user"></i></span> */}
                        <p className="course_time">Validity - {duration} days</p>
                        {/* <span className="time_icon"><i className="fa-regular fa-clock"></i></span> */}
                    </div>
                    <p className="course_desc_home">
                    {(courseData.description).substring(0, 35)}...
                        <a href="/more-info" onClick={handleKnowMore}>Know More</a>
                    </p>
                    {/* <h5 className="price"><span className="amount"><s>₹ 1999 /-</s></span></h5> */}
                    {/* <h5 className="price"><span className="amount">₹ {price} /-</span></h5> */}
                    {feedbackShowInWeb && rating > 0.0 ?
                    <>
                    <div className="ratingBodyDesign">
                        <div className="ratingNumber">
                            <span className="ratingNumberStyle">{rating.toFixed(1)}</span>
                        </div>
                        <div className="ratingStar">
                                  {/* <p className="ratingDescription"></p> */}
                                  
                                  <StarRatings
                                  rating={rating}
                                  isSelectable={false}
                                  starRatedColor="#FFC414"
                                  numberOfStars={5}
                                  name='rating'
                                  starDimension = "20px"
                                  starSpacing = "2px"
                                  />
                                   </div>
                    </div></>
                     : null}
                    <div className="PriceSecStyle">
                    <h5 className="price"><span className="amount">₹ {isActiveOffer ? offerPrice : price} /-</span></h5>
                    {isActiveOffer ?
                    <p className="offerPrice"><span className="offerAmount"><strike>₹ {price} /-</strike></span></p> : null}
                    </div>
                    {isActiveOffer ?
                    <div className="offerSecStyle">
                        {/* <p className="offerName"><i><b>{offerName}</b> Offer! </i> Valid upto {offerEndDate}</p> */}
                        <span className="offerName"><i><b>{offerName ? offerName : specialOfferName}</b> Offer! </i></span>
                        <span className="offerDuration">Valid upto {offerEndDate}</span>
                        {/* <p className="offerDuration">Valid upto {offerEndDate}</p> */}
                    </div> : null}
                    {/* Starting From  */}
                 
                   <div className="course_card_footer">
                    <div className="course_ftr">
                   
                            <button className="subscribe_btn" onClick={() => courseTypeName == "Short" ? handleBuyNow() : handleSubscription()}>{courseTypeName == "Short" ? "Buy Now" : existingFlag == true ? 'Add to cart' : 'Individual'}</button>
                            {/* <button className="knowmore_btn" onClick={() => handleKnowMore()}>Know More</button> */}
                             <button className="knowmore_btn knowmore" onClick={() => handleTeamsRedirect()}>Teams</button>
                    
                        </div>
                   </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CourseItem;